import firebase from "../Firebase.js";

export function getWebsiteDBRef(siteId: string) {
  return firebase.database().ref("/website/" + siteId);
}
export function getProductsDBRef(siteId: string) {
  return firebase.database().ref("/products/" + siteId);
}

export function getBrandsStorageRef(siteId: string) {
  return firebase
    .storage()
    .ref("/" + siteId)
    .child("brands");
}
export function getPresStorageRef(siteId: string) {
  return firebase
    .storage()
    .ref("/" + siteId)
    .child("presentation");
}
export function getProductStorageRef(siteId: string) {
  return firebase
    .storage()
    .ref("/" + siteId)
    .child("products");
}
